import React from 'react';
import './Button.scss';
import { Icon } from "@phosphor-icons/react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  icon?: Icon;
  iconPosition?: 'start' | 'end';
  iconSize?: number;
  iconColor?: 'white' | 'black' | 'green' | 'red' | 'yellow';
  iconWeight?: 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone';
  buttonStyle?: 'primary' | 'secondary' | 'accent' | 'special';
  buttonSize?: 'rg' | 'lg' | 'sm'
}

export function Button({
  label = 'Okay',
  icon = void 0,
  iconPosition = 'start',
  iconSize = 24,
  iconColor = 'white',
  iconWeight = 'regular',
  buttonStyle = 'primary',
  buttonSize = 'rg',
  ...rest
}: ButtonProps) {
  const StartIcon = iconPosition === 'start' ? icon : null;
  const EndIcon = iconPosition === 'end' ? icon : null;
  const classList = [];
  classList.push(`btn-${buttonStyle}`);
  classList.push(`btn-${buttonSize}`);

  return (
    <button data-component="Button" className={"btn " + classList.join(' ')} {...rest}>
      {StartIcon && (
        <StartIcon size={iconSize} color={iconColor} weight={iconWeight} />
      )}
      <span className="label">{label}</span>
      {EndIcon && (
        <EndIcon size={iconSize} color={iconColor} weight={iconWeight} />
      )}
    </button>
  );
}
